"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/BusinessComponents/ViewDetailsLink";

import React from "react";
import { ShellLink } from "@/src/components";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { ROUTER_PATH } from "@/src/config/router";

const I18n = I18nUtil.createScoped(Translations);

interface ViewDetailsLinkProps {
  href: string;
}

export function buildStockDetailHref(symbol: string): string {
  return `${ROUTER_PATH.STOCK_DETAIL}/${encodeURIComponent(symbol)}`;
}

export function buildStockDetailModuleHref(
  symbol: string,
  module: string,
): string {
  return `${buildStockDetailHref(symbol)}/${encodeURIComponent(module)}`;
}

export function buildCryptoDetailHref(assetId: string): string {
  return `${ROUTER_PATH.CRYPTO_TOKEN}/${encodeURIComponent(assetId)}`;
}

export const ViewDetailsLink: React.FC<ViewDetailsLinkProps> = ({ href }) => (
  <ShellLink href={href} className="self-start no-underline">
    <span
      className={cn(
        "button sm_button secondary_button button_s ml-1px min-w-[80px] gap-1 px-2 py-1.5 h-auto",
      )}
    >
      {I18n.t("View Details")}
      <Icon name="right-arrow-alt" size={16} />
    </span>
  </ShellLink>
);
